//
// Action types
//

export const PUSH_CONTAINERS = "PUSH_CONTAINERS";
export const RESTORE_CONTAINERS_POSITION = "RESTORE_CONTAINERS_POSITION";
export const SET_FULL_SCREEN_MODE = "SET_FULL_SCREEN_MODE";
export const SET_IFRAME_MODE = "SET_IFRAME_MODE";
export const SET_SOCIAL_SHARING_ENABLED = "SET_SOCIAL_SHARING_ENABLED";
export const SET_COMPLEX_MENU_ENABLED = "SET_COMPLEX_MENU_ENABLED";
export const SET_AFFIX_HEADER_OFFSET_TOP = "SET_AFFIX_HEADER_OFFSET_TOP";
export const SET_STICKY_TITLE_BAR_HEIGHT = "SET_STICKY_TITLE_BAR_HEIGHT";
export const SET_HEADER_SHOWN = "SET_HEADER_SHOWN";
export const SET_MOBILE_HEADER_HIDDEN = "SET_MOBILE_HEADER_HIDDEN";
export const SET_BACKDROP_OPEN = "SET_BACKDROP_OPEN";
export const SET_COMPLEX_SUB_MENU_ENABLED = "SET_COMPLEX_SUB_MENU_ENABLED";
export const SET_PAGE_SCROLLED = "SET_PAGE_SCROLLED";

//
// Action creators
//

export function pushContainers(pushableContainersOffset) {
  return {
    type: PUSH_CONTAINERS,
    pushableContainersOffset
  };
}

export function restoreContainersPosition() {
  return {
    type: RESTORE_CONTAINERS_POSITION
  };
}

export function setFullScreenMode(fullScreenMode = false) {
  return {
    type: SET_FULL_SCREEN_MODE,
    fullScreenMode
  };
}

export function setIFrameMode(iFrameMode = false) {
  return {
    type: SET_IFRAME_MODE,
    iFrameMode
  };
}

export function setSocialSharingEnabled(enabled) {
  return {
    type: SET_SOCIAL_SHARING_ENABLED,
    enabled
  };
}

export function setComplexMenuEnabled(enabled) {
  return {
    type: SET_COMPLEX_MENU_ENABLED,
    enabled
  };
}

export function setComplexSubMenuEnabled(enabled) {
  return {
    type: SET_COMPLEX_SUB_MENU_ENABLED,
    enabled
  };
}

export function setAffixHeaderOffsetTop(affixHeaderOffsetTop) {
  return {
    type: SET_AFFIX_HEADER_OFFSET_TOP,
    affixHeaderOffsetTop
  };
}

export function setStickyTitleBarHeight(stickyTitleBarHeight) {
  return {
    type: SET_STICKY_TITLE_BAR_HEIGHT,
    stickyTitleBarHeight
  };
}

export function setHeaderShown(showHeader) {
  return {
    type: SET_HEADER_SHOWN,
    showHeader
  };
}

export function setMobileHeaderHidden(hideMobileHeader) {
  return {
    type: SET_MOBILE_HEADER_HIDDEN,
    hideMobileHeader
  };
}

export function setBackdropOpen(isBackdropOpen) {
  return {
    type: SET_BACKDROP_OPEN,
    isBackdropOpen
  };
}

export function setPageScrolled(isPageScrolled) {
  return {
    type: SET_PAGE_SCROLLED,
    isPageScrolled
  };
}

function pushContainersHandler(state, pushableContainersOffset) {
  return { ...state, pushableContainersOffset };
}

function restoreContainersPositionHandler(state) {
  return {
    ...state,
    pushableContainersOffset: 0
  };
}

function setFullScreenModeHandler(state, fullScreenMode) {
  return { ...state, fullScreenMode };
}

function setIFrameModeHandler(state, iFrameMode) {
  return { ...state, iFrameMode };
}

function setSocialSharingEnabledHandler(state, enabled) {
  return { ...state, socialSharingEnabled: enabled };
}

function setComplexMenuEnabledHandler(state, enabled) {
  return { ...state, complexMenuEnabled: enabled };
}

function setComplexSubMenuEnabledHandler(state, enabled) {
  return { ...state, complexSubMenuEnabled: enabled };
}

function setAffixHeaderOffsetTopHandler(state, affixHeaderOffsetTop) {
  return { ...state, affixHeaderOffsetTop };
}

function setStickyTitleBarHeightHandler(state, stickyTitleBarHeight) {
  return { ...state, stickyTitleBarHeight };
}

function setHeaderShownHandler(state, showHeader) {
  return { ...state, showHeader };
}

function setMobileHeaderHiddenHandler(state, hideMobileHeader) {
  return { ...state, hideMobileHeader };
}

function setBackdropOpenHandler(state, isBackdropOpen) {
  return { ...state, isBackdropOpen };
}

function setPageScrolledHandler(state, isPageScrolled) {
  return { ...state, isPageScrolled };
}

//
// Reducer and handlers
//
export default function stylingReducer(state, action) {
  switch (action && action.type) {
    case PUSH_CONTAINERS:
      return pushContainersHandler(state, action.pushableContainersOffset);

    case RESTORE_CONTAINERS_POSITION:
      return restoreContainersPositionHandler(state);

    case SET_FULL_SCREEN_MODE:
      return setFullScreenModeHandler(state, action.fullScreenMode);

    case SET_IFRAME_MODE:
      return setIFrameModeHandler(state, action.iFrameMode);

    case SET_SOCIAL_SHARING_ENABLED:
      return setSocialSharingEnabledHandler(state, action.enabled);

    case SET_COMPLEX_MENU_ENABLED:
      return setComplexMenuEnabledHandler(state, action.enabled);

    case SET_COMPLEX_SUB_MENU_ENABLED:
      return setComplexSubMenuEnabledHandler(state, action.enabled);

    case SET_AFFIX_HEADER_OFFSET_TOP:
      return setAffixHeaderOffsetTopHandler(state, action.affixHeaderOffsetTop);

    case SET_STICKY_TITLE_BAR_HEIGHT:
      return setStickyTitleBarHeightHandler(state, action.stickyTitleBarHeight);

    case SET_HEADER_SHOWN:
      return setHeaderShownHandler(state, action.showHeader);

    case SET_MOBILE_HEADER_HIDDEN:
      return setMobileHeaderHiddenHandler(state, action.hideMobileHeader);

    case SET_BACKDROP_OPEN:
      return setBackdropOpenHandler(state, action.isBackdropOpen);

    case SET_PAGE_SCROLLED:
      return setPageScrolledHandler(state, action.isPageScrolled);

    default:
      return (
        state || {
          pushableContainersOffset: 0,
          affixHeaderOffsetTop: 0,
          showHeader: true,
          isBackdropOpen: false,
          hideMobileHeader: true,
          isPageScrolled: false
        }
      );
  }
}
